// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Rows.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, view, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common';
export const Rows = () => <view.div css={{
  layout: 'column',
  gap: 'medium',
  '& > *': {
    width: css.value('350px')
  }
}}>
    <TextArea label="Biography (3 rows, default)" defaultValue={EXAMPLE_TEXT} />
    <TextArea label="Biography (6 rows)" rows={6} defaultValue={EXAMPLE_TEXT} />
  </view.div>;